var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "my-4" }, [_vm._v(" Preview ")]),
    _c("div", { staticClass: "bg-gray-100 flex px-4 py-4 rounded-md" }, [
      _c(
        "div",
        {
          staticClass:
            "shadow-2xl bg-white text-sm rounded-md px-2 py-2 relative"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "bg-white absolute w-4 h-4 right-0 top rounded-full cursor-pointer",
              staticStyle: { top: "-6px", right: "-6px" }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "stroke-current text-gray-400 ",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    }
                  })
                ]
              )
            ]
          ),
          _c("span", { staticClass: "text-gray-700" }, [
            _vm._v(_vm._s(_vm.config.welcomeMessage.text))
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }